import * as React from 'react';
import { get, set } from '@rc-component/util';
import useLayoutEffect from '@rc-component/util/lib/hooks/useLayoutEffect';
import { clsx } from 'clsx';
import { isPlainObject } from '../_util/is';
import { responsiveArrayReversed } from '../_util/responsiveObserver';
import Col from '../grid/col';
import { FormContext, FormItemPrefixContext } from './context';
import ErrorList from './ErrorList';
import FallbackCmp from './style/fallbackCmp';
const GRID_MAX = 24;
const FormItemInput = (props) => {
    const { prefixCls, status, labelCol, wrapperCol, children, errors, warnings, _internalItemRender: formItemRender, extra, help, fieldId, marginBottom, onErrorVisibleChanged, label, } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = React.useContext(FormContext);
    const { classNames: contextClassNames, styles: contextStyles } = formContext;
    const mergedWrapperCol = React.useMemo(() => {
        let mergedWrapper = { ...(wrapperCol || formContext.wrapperCol || {}) };
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [undefined, ...responsiveArrayReversed];
            list.forEach((size) => {
                const _size = size ? [size] : [];
                const formLabel = get(formContext.labelCol, _size);
                const formLabelObj = isPlainObject(formLabel) ? formLabel : {};
                const wrapper = get(mergedWrapper, _size);
                const wrapperObj = isPlainObject(wrapper) ? wrapper : {};
                if ('span' in formLabelObj &&
                    !('offset' in wrapperObj) &&
                    formLabelObj.span < GRID_MAX) {
                    mergedWrapper = set(mergedWrapper, [..._size, 'offset'], formLabelObj.span);
                }
            });
        }
        return mergedWrapper;
    }, [wrapperCol, formContext.wrapperCol, formContext.labelCol, label, labelCol]);
    const className = clsx(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = React.useMemo(() => {
        const { labelCol: _labelCol, wrapperCol: _wrapperCol, ...rest } = formContext;
        return rest;
    }, [formContext]);
    const extraRef = React.useRef(null);
    const [extraHeight, setExtraHeight] = React.useState(0);
    useLayoutEffect(() => {
        if (extra && extraRef.current) {
            setExtraHeight(extraRef.current.clientHeight);
        }
        else {
            setExtraHeight(0);
        }
    }, [extra]);
    const inputDom = (React.createElement("div", { className: `${baseClassName}-control-input` },
        React.createElement("div", { className: clsx(`${baseClassName}-control-input-content`, contextClassNames?.content), style: contextStyles?.content }, children)));
    const formItemContext = React.useMemo(() => ({ prefixCls, status }), [prefixCls, status]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? (React.createElement(FormItemPrefixContext.Provider, { value: formItemContext },
        React.createElement(ErrorList, { fieldId: fieldId, errors: errors, warnings: warnings, help: help, helpStatus: status, className: `${baseClassName}-explain-connected`, onVisibleChanged: onErrorVisibleChanged }))) : null;
    const extraProps = {};
    if (fieldId) {
        extraProps.id = `${fieldId}_extra`;
    }
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? (React.createElement("div", { ...extraProps, className: `${baseClassName}-extra`, ref: extraRef }, extra)) : null;
    const additionalDom = errorListDom || extraDom ? (React.createElement("div", { className: `${baseClassName}-additional`, style: marginBottom ? { minHeight: marginBottom + extraHeight } : {} },
        errorListDom,
        extraDom)) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? (formItemRender.render(props, { input: inputDom, errorList: errorListDom, extra: extraDom })) : (React.createElement(React.Fragment, null,
        inputDom,
        additionalDom));
    return (React.createElement(FormContext.Provider, { value: subFormContext },
        React.createElement(Col, { ...mergedWrapperCol, className: className }, dom),
        React.createElement(FallbackCmp, { prefixCls: prefixCls })));
};
export default FormItemInput;
